export {PageSamplingPointsSettings} from './pages/PageSamplingPointsSettings'
